import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Article — renders a semantic <article> element.
 *
 * This atom is the canonical integration point for:
 * - JSON-LD structured data (itemScope, itemType, itemProp attributes)
 * - Schema.org microdata
 * - Any future article-level instrumentation applied uniformly across content types
 *
 * @atomic-tier Atom
 * @category Semantic
 */

export type ArticleProps = React.HTMLAttributes<HTMLElement>

const Article = React.forwardRef<HTMLElement, ArticleProps>(
  ({ className, children, ...props }, ref) => (
    <article ref={ref} className={cn(className)} {...props}>
      {children}
    </article>
  ),
)
Article.displayName = "Article"

export { Article }
